import { VStack } from "@/components/Layout";
import { SupportedCountry } from "@/constants/country";

import {
  type AddressData,
  AddressReadOnly,
} from "./-components/AddressReadOnly";
import { InternationalAddressForm } from "./-components/InternationalAddressForm";
import { JapaneseAddressForm } from "./-components/JapaneseAddressForm";
import type { AddressFormConfig } from "./-types";
import { useAddressFormContext } from "./useAddressFormContext";

interface AddressFormProps extends AddressFormConfig {
  readOnly?: boolean;
  readOnlyData?: AddressData;
}

export function AddressForm({
  className,
  isCountryRequired,
  isStateProvinceRequired,
  isCityRequired,
  isStreetAddressRequired,
  isPostalCodeRequired,
  readOnly = false,
  readOnlyData,
}: AddressFormProps) {
  const { values } = useAddressFormContext();

  // 読み取り専用モードの場合
  if (readOnly && readOnlyData) {
    return (
      <VStack className={className}>
        <AddressReadOnly data={readOnlyData} />
      </VStack>
    );
  }

  const isJapan = values.countryCode === SupportedCountry.JP;

  return (
    <VStack className={className}>
      {isJapan ? (
        <JapaneseAddressForm
          isCountryRequired={isCountryRequired}
          isStateProvinceRequired={isStateProvinceRequired}
          isCityRequired={isCityRequired}
          isStreetAddressRequired={isStreetAddressRequired}
          isPostalCodeRequired={isPostalCodeRequired}
        />
      ) : (
        <InternationalAddressForm
          isCountryRequired={isCountryRequired}
          isStateProvinceRequired={isStateProvinceRequired}
          isCityRequired={isCityRequired}
          isStreetAddressRequired={isStreetAddressRequired}
          isPostalCodeRequired={isPostalCodeRequired}
        />
      )}
    </VStack>
  );
}
